import api from "API/Api"
import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"

const EditServiceType = () => {
  const { id } = useParams()
  const [data, setData] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getInfo = async () => {
      try {
        const res = await api.get("service-types")
        const types = Array.isArray(res.data.data) ? res.data.data : []
        const found = types.find(t => t.id == id)
        if (found) setData(found)
      } catch (e) { console.error(e) }
    }
    getInfo()
  }, [id])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const res = await api.put("service-types/" + id, values)
      if (res.data.success === true) setSubmitted(true)
    } catch (error) {
      // Handled by global interceptor
    }
    setLoading(false)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Edit Service Type</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/service-types" className="dashBtn">
                <i className="fas fa-chevron-left"></i> <b>Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm style={{ position: "relative" }} className="form-horizontal"
            onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
            <div className="mb-3">
              <AvField name="name" label="Service Type Name" value={data.name || ""} className="form-control"
                placeholder="Enter service type name" type="text" required />
            </div>
            <div className="mb-3">
              <AvField name="description" label="Description" value={data.description || ""} className="form-control"
                placeholder="Enter description" type="textarea" />
            </div>
            <div className="mb-3">
              <AvField name="status" label="Status" type="select" className="form-control" required value={data.status || "active"}>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </AvField>
            </div>
            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success"><strong>Service Type Updated!</strong></UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (<><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></>) : (<span>Update Service Type</span>)}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditServiceType
